<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          @if (invoices.length && !isLoading.list) {
            <div class="table-responsive m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30">
              <table class="m-datatable__table">
                <thead class="m-datatable__head">
                <tr class="m-datatable__row m-datatable__row--head">
                  <th class="m-datatable__cell">{{ 'invoice-list.id' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'invoice-list.departureData' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'invoice-list.status' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'invoice-list.were' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'invoice-list.received' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'invoice-list.description' | transloco }}</th>
                </tr>
                </thead>
                <tbody class="m-datatable__body">
                  @for (inv of invoices; track inv) {
                    <tr class="m-datatable__row">
                      <td class="m-datatable__cell"><a (click)="showInvoiceModal(inv)">{{ inv.id }}</a></td>
                      <td class="m-datatable__cell">{{ inv.sendDate | date:'dd.MM.yy / HH:mm' }}</td>
                      <td class="m-datatable__cell">
                        <span class="m-badge  m-badge--{{ statusList[inv.status]?.badge }} m-badge--wide m-badge--rounded">
                          {{ 'hx.enum.InvoiceStatus.' + inv.status | transloco }}
                        </span>
                      </td>
                      <td class="m-datatable__cell">
                        <span class="m--margin-right-10">{{ inv.fromStore?.title | uiLabel }}</span>
                        <hc-icon icon="left-arrow"></hc-icon>
                        <span>{{ inv.toStore?.title | uiLabel }}</span>
                      </td>
                      <td class="m-datatable__cell">
                        <span *ngIf="inv.senderUser" class="m--margin-right-10"
                            [ngbTooltip]="inv.senderUser.fullname">{{ inv.senderUser.fullname | fio }}</span>
                        <hc-icon icon="left-arrow" *ngIf="inv.receiveUser"></hc-icon>
                        <span *ngIf="inv.receiveUser"
                            [ngbTooltip]="inv.receiveUser.fullname">{{ inv.receiveUser.fullname | fio }}</span>
                      </td>
                      <td class="m-datatable__cell">{{ inv.description }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          <hx-loader [length]="invoices.length" [isLoading]="isLoading.list"></hx-loader>
        </div>
      </div>
    </div>
  </div>
</div>

